export enum CrmType {
  None = 0,
  Eleads = 1,
  DealerSocket = 2,
  VinSolutions = 3,
}

export enum CrmStatus {
  None = 0,
  Pending = 1,
  Success = 2,
  Failed = 3,
  MissingData = 4,
}

export const getCrmName = (crm: CrmType) => {
  switch (crm) {
    case CrmType.Eleads:
      return 'CDK CRM';
    case CrmType.DealerSocket:
      return 'DealerSocket';
    case CrmType.VinSolutions:
      return 'VinSolutions';
    default:
      return '';
  }
};

export const isCrmIntegrated = (crm?: CrmType) => {
  switch (crm) {
    case CrmType.DealerSocket:
    case CrmType.Eleads:
    case CrmType.VinSolutions:
      return true;
    default:
      return false;
  }
};

export const isCrmReactive = (crm?: CrmType) => {
  switch (crm) {
    case CrmType.DealerSocket:
    case CrmType.Eleads:
      return true;
    default:
      return false;
  }
};
